module.exports = __webpack_public_path__ + "static/media/Icono usuarios.668072e9.svg";